export const PhoneInputMaxLength = 15;
